import React from 'react';

const StipSheetModal = ({ appData, numberWithCommas, dealStips }) => {
    return (
        <div className="modal fade" id="stip_sheet_modal" tabIndex={-1} role="dialog" aria-labelledby="stip_sheet_modal" aria-hidden="true">
            <div className="modal-dialog modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="stipsmodallabel">Stipulation Sheet</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <div className="table-responsive">
                            <p className="CB_Header">Tracir Financial Services</p>
                            <p className="St_sub_Header">The following is a detailed list of missing stipulations that are required to be cleared for Tracir Financial Services to release funds on the purchase of the retail installment sales contract outlined&nbsp;below. &nbsp;Please contact Tracir Financial Services with any ?&#39;s or concerns. &nbsp;Thanks!</p>
                            <table className="table table-striped table-bordered">
                                <tbody>
                                    <tr>
                                        <td colSpan={2} rowSpan={1} className="CI_Modal"><h4>Customer Information</h4></td>
                                        <td>&nbsp;</td>
                                        <td colSpan={2} rowSpan={1} className="FI_Modal"><h4>Approved Financing Information</h4></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Applicant</h5></td>
                                        <td><span className="CB_Modal_Item" >{appData.rec_app_first_name} {appData.rec_app_last_name}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Max Advance</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_unpaid_balance)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Co-Applicant, if any</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_coapp_first_name} {appData.rec_coapp_last_name}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>GAP Protection</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_gap)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Application #</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_application_number}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>FL Doc Stamp Tax, if any</h5></td>
                                        <td className="CB_Modal_Value"><span>$&nbsp;${numberWithCommas(appData.rec_credit_life_ins)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Status</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_app_status}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Total Amount Financed</h5></td>
                                        <td className="CB_Modal_Value"><span>${numberWithCommas(appData.rec_est_amt_financed)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Dealer</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_dealer_name}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Discount/Lender Fee</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.rec_calc_discount}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Dealer Phone #</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_dealer_phone}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Origination Fee</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.rec_orig_fee ? parseFloat(appData.rec_orig_fee).toFixed(2) : '0.00'}</span></td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2} rowSpan={1} className="VI_Header"><h4>Vehicle Information</h4></td>
                                        <td>&nbsp;</td>
                                        <td><h5 className="dealer_proceeds"><strong>Dealer Proceeds</strong></h5></td>
                                        <td className="CB_Modal_Value_DP"><span className="CB_Modal_Value_DP">${numberWithCommas(appData.rec_dealer_proceeds)}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>New/Used</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_year}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Maximum # of Payments</h5></td>
                                        <td className="CB_Modal_Value"><span>{appData.rec_term_months}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Make</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_make}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Maximum Payment</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.rec_payment}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Model</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_model}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Minimum Down Payment</h5></td>
                                        <td className="CB_Modal_Value"><span>${appData.req_cash_down}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Trim</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_veh_trim}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Rate</h5></td>
                                        <td rowSpan={1} className="CB_Modal_Value"><span>{appData.rec_buyrate}%</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>VIN #</h5></td>
                                        <td><span className="CB_Modal_Item">{appData.rec_vin}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Payment Frequency</h5></td>
                                        <td rowSpan={1} className="CB_Modal_Value"><span>{appData.rec_payment_freq}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Mileage</h5></td>
                                        <td><span className="CB_Modal_Item">{numberWithCommas(appData.rec_veh_mileage)}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Package Received Date</h5></td>
                                        <td rowSpan={1} className="CB_Modal_Value"><span>{appData.cr_received_date && appData.cr_received_date.includes('NaN') ? '---' : appData.cr_received_date}</span></td>
                                    </tr>
                                    <tr>
                                        <td><h5>Last Verification Update</h5></td>
                                        <td><span className="CB_Modal_Item">{''}</span></td>
                                        <td>&nbsp;</td>
                                        <td><h5>Initial Stip Date</h5></td>
                                        <td className="CB_Modal_Value"><span>{appData.vi_entry_date && appData.vi_entry_date.includes('NaN') ? '---' : appData.vi_entry_date}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="St_Header">
                                Missing stips must be recieved by <b>{appData.vi_end_date && appData.vi_end_date.includes('NaN') ? '[Contact Tracir Financial Services for the due date]' : appData.vi_end_date}</b> or package may be returned.
                            </p>
                            <div className="ST__Value" style={{ fontWeight: 'bold' }}>
                                <ul>
                                    {dealStips.map((dealStip, index) => {
                                        if (String(dealStip).includes('|')) {
                                            const stipParts = String(dealStip).split('|');
                                            const stipName = stipParts[0];
                                            const stipStatus = stipParts[1];
                                            const stipType = stipParts[2];
                                            if (stipStatus === 'Failed' && stipType === 'UW') {
                                                return <li key={index}>{stipName}</li>;
                                            }
                                            return null;
                                        }
                                        return null;
                                    })}
                                </ul>
                            </div>
                            <p className="St_Header"><span><span>Tracir Financial Services still needs to complete the following verification tasks:</span></span></p>
                            <div className="ST__Value">
                                <ul>
                                    {dealStips.map((dealStip, index) => {
                                        if (String(dealStip).includes('|')) {
                                            const stipParts = String(dealStip).split('|');
                                            const stipName = stipParts[0];
                                            const stipStatus = stipParts[1];
                                            const stipType = stipParts[2];
                                            if ((stipStatus === 'Failed' || stipStatus === 'Incomplete') && stipType === 'VF') {
                                                return <li key={index}>{stipName}</li>;
                                            }
                                            return null;
                                        }
                                        return null;
                                    })}
                                </ul>
                            </div>
                            <p className="St_Header"><span><span>Additional comments:</span></span></p>
                            <p className="St_Header"><span><span>Allow up to 24 hour response time for updated stips.&nbsp;</span></span></p>
                            <div>
                                <table align="center" className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td><span className="Contact">Underwriting Phone #</span></td>
                                            <td><span className="Contact">877-280-9267</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="Contact">FAX YOUR LOAN PACKET to</span></td>
                                            <td><span className="Contact">888-769-3390</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(StipSheetModal);
